/* ==========================================================================
   UiPopper > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'UiPopper',
    init: true,
    start: true,
    events: true,
    css: {
        popper: 'ui-popper',
        arrow: 'ui-popper__arrow'
    },
    tag: 'span',
    arrow: true,
    hasClick: false,
    hasContentSelectable: false,
    contentSelectableStyle: `
        top: -12px;
        left: -12px;
        width: calc(100% + 24px);
        height: calc(100% + 24px);
        z-index: -1;
        background-color: transparent;
    `
};

module.exports = () => config;
